import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../hooks/useTranslation';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../styles/Projects.css';

const Projects = () => {
  const { t } = useTranslation();

  const projects = [
    {
      id: 1,
      title: t('projects.dmhCounter.title'),
      description: t('projects.dmhCounter.description'),
      technologies: [t('projectTechnologies.m5stick'), t('projectTechnologies.blynk'), t('projectTechnologies.debian'), t('projectTechnologies.raspberrypi'), t('projectTechnologies.apiYaskawa')],
      image: "m5.webp",
      githubUrl: null,
      demoUrl: null
    },
    {
      id: 2,
      title: t('projects.compressorEfficiency.title'),
      description: t('projects.compressorEfficiency.description'),
      technologies: [t('projectTechnologies.vfd'), t('projectTechnologies.energyEfficiency'), t('projectTechnologies.roiAnalysis'), t('projectTechnologies.compressor'), t('projectTechnologies.economy')],
      image: "EG37.png",
      imageClassName: "project-image-cover",
      githubUrl: null,
      demoUrl: null
    },
    {
      id: 3,
      title: t('projects.threeDPrinting.title'),
      description: t('projects.threeDPrinting.description'),
      technologies: [t('projectTechnologies.design3d'), t('projectTechnologies.printing3d'), t('projectTechnologies.cad'), t('projectTechnologies.formlabs'), t('projectTechnologies.sustainability')],
      image: "formlabs.webp",
      githubUrl: null,
      demoUrl: null
    }
  ];

  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

  return (
    <section id="projects" className="projects-section">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {t('projects.title')}
      </motion.h2>
      <div className="projects-grid">
        {projects.map((project, index) => (
          <motion.div
            key={project.id}
            className="project-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            whileHover={!isMobile ? { scale: 1.02, y: -5, boxShadow: "0 10px 30px rgba(255, 204, 0, 0.2)" } : {}}
            whileTap={{ scale: 0.98 }}
          >
            <img
              src={project.image}
              alt={project.title}
              className={`project-image ${project.imageClassName || ''}`}
              loading="lazy"
            />
            <div className="project-content">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="project-technologies">
                {project.technologies.map((tech, i) => (
                  <span key={i} className="tech-tag">{tech}</span>
                ))}
              </div>

              <div className="project-links">
                {project.githubUrl && (
                  <a href={project.githubUrl} target="_blank" rel="noopener noreferrer" className="project-link-btn" aria-label="Voir le code sur GitHub">
                    <FontAwesomeIcon icon={faGithub} /> Code
                  </a>
                )}
                {project.demoUrl && (
                  <a href={project.demoUrl} target="_blank" rel="noopener noreferrer" className="project-link-btn" aria-label="Voir la démo live">
                    <FontAwesomeIcon icon={faExternalLinkAlt} /> Demo
                  </a>
                )}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Projects;